import React ,{ useState }from "react";
import PdtHeader from "./pdtheader";
import Form from 'react-bootstrap/Form';
import AmbSSTCU from "./ambsstcu";
import BuildCUNew from "./buildcunew";
import BuildUCNew from "./builducnew";
import FooterPrice from "./footerprice";
export default function BuildSystem(props) {
    const [hideBuilder,setBuilder] = useState(false);
    const [CUnoModels,setCUModels] = useState(false);
    const [UCnoModels,setUCModels] = useState(false);
    const changeView = (view)=>{
        setBuilder(view);
    }
    return (
        <>
        {/* <Header /> */}
        <PdtHeader tool={props.tool} unit={"System"} />
        <AmbSSTCU boxloaded={props.boxloaded} onBuilder={changeView}  tool={props.tool} navigate={props.navigate} activevalue={props.activevalue_CU} update={props.update_cu} />
        {/* <div className="custom_container" hidden={hideBuilder}> */}
        <div  >

        <div className="row">
            <div className="col-sm-12">
                <BuildCUNew setCUModels={setCUModels}  updateNewPrice={props.updateNewPrice} boxloaded={props.boxloaded} tool={props.tool} navigate={props.navigate} activevalue={props.activevalue_CU} update={props.update_cu} />
            </div>
            <div className="col-sm-12">
                <BuildUCNew setUCModels={setUCModels} CUnoModels={CUnoModels} UCnoModels={UCnoModels} updateNewPrice={props.updateNewPrice} boxloaded={props.boxloaded} tool={props.tool} navigate={props.navigate} condn_units_count={props.activevalue_CU.count}  activevalue={props.activevalue_UC} update={props.update_uc} update_uc_min_and_zone={props.update_uc_min_and_zone}/>
            </div>
        </div>
        </div>
        <div >
        <FooterPrice match={props.match} tool={props.tool} CUnoModels={CUnoModels} UCnoModels={UCnoModels} navigate={props.navigate} />
        </div>

        </>
    )
}